/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
import router from '@/router'

export default {
    createWorkspace({ commit }, payload) {
      var content = `<h2><span class="ql-font-selected">정보통신공학과 프로그래밍 클래스입니다.</span></h2><br />
      <span class="ql-font-selected">여기서 프로젝트 관리와 과제제출을 할 수 있어요.</span><br />
      <span class="ql-font-selected">질문 사항이 있다면 언제든 QnA에 남겨주세요 :D</span><br /><br />
      <iframe class="ql-video ql-align-center" src="https://www.youtube.com/embed/lyo7hd7-mKM" width="560" height="338"></iframe> `
      var spaceInfo = {"title": payload.title, "detail": content}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/create", spaceInfo)
          .then((response) => {
            if(response.data.result == 'success') {
              commit("SET_ACTIVE_SPACE", response.data.workspaceInfo)
              router.push(router.currentRoute.query.to || '/pages/space/invite')
            }
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateWorkspaceTags(context, payload){
      // var spaceInfo = {"tags": payload.tags, "workspace_id": payload.id}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/update/tags", payload)
        .then((response) => {
          if(response.data.result == 'success') {
            resolve(response)
          }else{
            reject(response)
          }
        }).catch((error) => { reject(error) })
      })
    },
    updateWorkspaceDetail(context, payload){
      // var spaceInfo = {"tags": payload.tags, "workspace_id": payload.id}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/update/detail", payload)
          .then((response) => {
            if(response.data.result == 'success') {
              resolve(response)
            }else{
              reject(response)
            }
          })
          .catch((error) => { reject(error) })
      })
    },
    updateWorkspaceTitle({commit}, payload){
      var spaceInfo = {"title": payload.title, "workspace_id": payload.id}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/update/title", spaceInfo)
        .then((response) => {
          if(response.data.result == 'success') {
            commit("UPDATE_WORKSPACE_TITLE", payload)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    updateWorkspace({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/update", payload)
          .then((response) => {
            if(response.data.result == 'success') {
              commit("SET_ACTIVE_SPACE", response.data.data)
              resolve(response)
            }else{
              reject(response)
            }
          })
          .catch((error) => { reject(error) })
      })
    },
    deleteWorkspace({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/"+ payload)
          .then((response) => {
            // commit("SET_UNREAD", payload)
            // Remove this if you are getting meta like us
            // Use your own method to update email meta if you are fetching email meta
            // commit("UPDATE_UNREAD_META", payload)
            if(response.data.result == 'success') {
              commit("DELETE_WORKSPACE", payload)
              resolve(response)
            }else{
              reject(response)
            }
          })
          .catch((error) => { reject(error) })
      })
    },
    inviteWorkspace(context, payload) {
      var inviteInfo = {"workspace_id": payload.id, "emails": payload.emails}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/invite", inviteInfo)
          .then((response) => {
            resolve(response)
          }
        )
        .catch((error) => { reject(error) })
      })
    },
    getAllWorkspace({ commit }) {
      // var spaceInfo = {"title": payload.title, "detail": payload.detail}
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace")
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_WORKSPACE_LIST", response.data.data_list)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    getInvite({ commit }) {
      // var spaceInfo = {"title": payload.title, "detail": payload.detail}
      return new Promise((resolve, reject) => {
        axios.get("/api/invite")
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_INVITE_LIST", response.data.data_list)
            }
            resolve(response)
          }).catch((error) => { reject(error) })
        })
    },
    agreeInvite({commit}, payload){
      // var inviteInfo = {"workspace_id": payload.workspace_id, "invite_note_id": payload.id}
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/invite/agree", payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("ADD_WORKSPACE", response.data.data)
              resolve(response.data.data)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    deleteMember({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/member/delete", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit("DELETE_MEMBER_LIST", payload)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
      })
    },
    getWorkspace({ commit }, payload) {
      // var spaceInfo = {"title": payload.title, "detail": payload.detail}
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_ACTIVE_SPACE", response.data.data)
            }
            resolve(response)
          }).catch((error) => { reject(error) })
        })
    },
    getMembers({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/member/" + payload.id)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_WORKSPACE_MEMBERS_LIST", response.data.data_list)
            }
            resolve(response)
          }).catch((error) => { reject(error) })
        })
    },
    changeMemberLevel({ commit }, payload){
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/member/chang-level", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit("UPDATE_MEMBERS_LEVEL", response.data.data_list)
          }
          else{
            if (response.data.data_list){
              commit("UPDATE_MEMBERS_LEVEL", response.data.data_list)
            }
          }
          resolve(response)
        }).catch((error) => { reject(error) })
      })
    },
    secessionMemeber(context, payload){
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/member/secession/"+payload)
        .then((response) => {
          if(response.data.result == 'success'){
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    }
}
